/* src/app/core/modals/assign-stock/assign-stock.component.scss */
/*# sourceMappingURL=assign-stock.component.css.map */
